var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _c(
        "DefaultContentLayout",
        [
          _c(
            "div",
            { staticClass: "flex flex-row justify-between h-20 items-center" },
            [
              _c(
                "h1",
                {
                  staticClass:
                    "text-heading font-semibold font-outfit leading-10",
                },
                [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")]
              ),
              _c(
                "div",
                { staticClass: "flex flex-row" },
                [
                  _c("UIButton", {
                    staticClass: "ml-4 font-outfit",
                    attrs: {
                      buttonText: "Log hours",
                      variant: "black",
                      size: "lg",
                      disabled: !_vm.showLogHours,
                    },
                    on: {
                      click: function ($event) {
                        _vm.timeTrackerOpen = true
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function () {
                          return [_c("ClockIcon", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                      {
                        key: "hover-icon",
                        fn: function () {
                          return [
                            _c("ClockIconBlack", { staticClass: "w-4 h-4" }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "disabled",
                        fn: function () {
                          return [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  fill: "none",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      "clip-path": "url(#clip0_1989_5285)",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM7.25 3.75V8C7.25 8.25 7.375 8.48438 7.58437 8.625L10.5844 10.625C10.9281 10.8562 11.3938 10.7625 11.625 10.4156C11.8562 10.0687 11.7625 9.60625 11.4156 9.375L8.75 7.6V3.75C8.75 3.33437 8.41562 3 8 3C7.58437 3 7.25 3.33437 7.25 3.75Z",
                                        fill: "#717986",
                                      },
                                    }),
                                  ]
                                ),
                                _c("defs", [
                                  _c(
                                    "clipPath",
                                    { attrs: { id: "clip0_1989_5285" } },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          width: "16",
                                          height: "16",
                                          fill: "white",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
          _c("router-view", {
            attrs: { company: _vm.company, currentUser: _vm.currentUser },
          }),
          _vm.timeTrackerOpen
            ? _c("ProjectTimeTrackerModal", {
                attrs: {
                  currentUser: _vm.currentUser,
                  checkDateWeekDisable: _vm.checkDateWeekDisable,
                },
                on: { close: _vm.closeTimeTrackerModal },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }